import { ShieldCheckIcon } from './ShieldCheckIcon';

/**
 * author: Google
 * id FC112FD8-5338-49C0-B4E0-FE1816A71E74
 * name shield-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-check.svg
 * tags
 * - Account / User 
 */
export const ShieldTickIcon = ShieldCheckIcon;
export default ShieldTickIcon